import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { Parametro, ParametroPorItem } from "app/types/Parametro"
import * as parametrosActions from 'app/redux/parametrosSlice'
import * as parametrosPorItemActions from 'app/redux/parametrosPorItemSlice'

export type ObterParametrosInput = {
    fazerCache?: boolean
    usarCacheSePossivel?: boolean
    nomes?: string[]
}

export type ObterParametrosPorOidItemInput = {
    fazerCache?: boolean
    usarCacheSePossivel?: boolean
    nomes?: string[],
    oidItem: number
}

export async function obterParametros({
    fazerCache = true,
    usarCacheSePossivel = true,
    nomes = []
}: ObterParametrosInput): Promise<Parametro[]> {

    const parametrosRedux = store.getState().parametros
    
    // Usar Set para consulta O(1)
    const nomesSet = new Set(nomes)
    const nomesEmCache = new Set(Object.keys(parametrosRedux))

    // Identificar nomes faltantes de forma eficiente
    const nomesParaBuscar = usarCacheSePossivel
        ? nomes.filter(nome => !nomesEmCache.has(nome))
        : [...nomesSet]

    let parametrosNovos: Parametro[] = []
    if (nomesParaBuscar.length > 0) {
        parametrosNovos = await microuniversoApi.Parametro.obterVarios(nomesParaBuscar)
    }

    // Atualizar cache se necessário
    if (fazerCache && parametrosNovos.length > 0) {
        parametrosNovos.forEach(p => {
            store.dispatch(parametrosActions.inserirOuAtualizar(p))
        })
    }

    // Combinar resultados de forma eficiente
    return [
        ...parametrosNovos,
        ...(usarCacheSePossivel
            ? nomes
                .filter(nome => nomesEmCache.has(nome))
                .map(nome => ({ Nome: nome, Valor: parametrosRedux[nome] }))
            : []
        )
    ].filter(p => nomesSet.has(p.Nome))
}

export async function obterParametrosPorOidItem({
    fazerCache = true,
    usarCacheSePossivel = true,
    nomes = [],
    oidItem = 0
}: ObterParametrosPorOidItemInput): Promise<ParametroPorItem[]> {

    const state = store.getState().parametrosPorItem
    
    // Criar mapa de cache para acesso rápido
    const cacheMap = new Map<string, ParametroPorItem>()
    state.forEach(p => {
        if (p.oidItem === oidItem) {
            cacheMap.set(p.Nome, p)
        }
    })
/*
    nomes.forEach(nome => {
        if (usarCacheSePossivel && cacheMap.has(nome)) {
            console.log(`[AVISO] O parâmetro ["${nome}"] foi obtido através do cache.`)
        }
    })
*/
    const nomesSet = new Set(nomes)
    const nomesParaBuscar = usarCacheSePossivel
        ? nomes.filter(nome => !cacheMap.has(nome))
        : [...nomesSet]

    let parametrosNovos: Parametro[] = []
    if (nomesParaBuscar.length > 0) {
        parametrosNovos = await microuniversoApi.Parametro.obterVariosPorOidItem(nomesParaBuscar, oidItem)
    }

    // Converter e armazenar novos parâmetros
    const novosParametrosPorItem: ParametroPorItem[] = parametrosNovos.map(p => ({
        Nome: p.Nome,
        Valor: p.Valor,
        oidItem
    }))

    if (fazerCache && novosParametrosPorItem.length > 0) {
        novosParametrosPorItem.forEach(p => {
            store.dispatch(parametrosPorItemActions.inserirOuAtualizar(p))
        })
    }

    // Combinar resultados
    return [
        ...novosParametrosPorItem,
        ...(usarCacheSePossivel
            ? nomes
                .filter(nome => cacheMap.has(nome))
                .map(nome => cacheMap.get(nome)!)
            : []
        )
    ].filter(p => nomesSet.has(p.Nome))
}
